export default "__VITE_ASSET__449f0b0c__"